(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6339],{

/***/ 23795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Link_Link; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(28628);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(79674);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Link/linkClasses.js


function getLinkUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiLink', slot);
}
const linkClasses = (0,generateUtilityClasses/* default */.Z)('MuiLink', ['root', 'underlineNone', 'underlineHover', 'underlineAlways', 'button', 'focusVisible']);
/* harmony default export */ var Link_linkClasses = (linkClasses);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/style.js
var style = __webpack_require__(54844);
// EXTERNAL MODULE: ./node_modules/@mui/system/colorManipulator.js
var colorManipulator = __webpack_require__(2101);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Link/getTextDecoration.js


const colorTransformations = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};
const transformDeprecatedColors = color => {
  return colorTransformations[color] || color;
};
const getTextDecoration = ({
  theme,
  ownerState
}) => {
  const transformedColor = transformDeprecatedColors(ownerState.color);
  const color = (0,style/* getPath */.DW)(theme, `palette.${transformedColor}`, false) || ownerState.color;
  const channelColor = (0,style/* getPath */.DW)(theme, `palette.${transformedColor}Channel`);
  if ('vars' in theme && channelColor) {
    return `rgba(${channelColor} / 0.4)`;
  }
  return (0,colorManipulator/* alpha */.Fq)(color, 0.4);
};
/* harmony default export */ var Link_getTextDecoration = (getTextDecoration);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Link/Link.js
'use client';



const _excluded = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant", "sx"];














const useUtilityClasses = ownerState => {
  const {
    classes,
    component,
    focusVisible,
    underline
  } = ownerState;
  const slots = {
    root: ['root', `underline${(0,capitalize/* default */.Z)(underline)}`, component === 'button' && 'button', focusVisible && 'focusVisible']
  };
  return (0,composeClasses/* default */.Z)(slots, getLinkUtilityClass, classes);
};
const LinkRoot = (0,styled/* default */.ZP)(Typography/* default */.Z, {
  name: 'MuiLink',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`underline${(0,capitalize/* default */.Z)(ownerState.underline)}`], ownerState.component === 'button' && styles.button];
  }
})(({
  theme,
  ownerState
}) => {
  return (0,esm_extends/* default */.Z)({}, ownerState.underline === 'none' && {
    textDecoration: 'none'
  }, ownerState.underline === 'hover' && {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }, ownerState.underline === 'always' && (0,esm_extends/* default */.Z)({
    textDecoration: 'underline'
  }, ownerState.color !== 'inherit' && {
    textDecorationColor: Link_getTextDecoration({
      theme,
      ownerState
    })
  }, {
    '&:hover': {
      textDecorationColor: 'inherit'
    }
  }), ownerState.component === 'button' && {
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${Link_linkClasses.focusVisible}`]: {
      outline: 'auto'
    }
  });
});
const Link = /*#__PURE__*/react.forwardRef(function Link(inProps, ref) {
  const props = (0,DefaultPropsProvider/* useDefaultProps */.i)({
    props: inProps,
    name: 'MuiLink'
  });
  const {
      className,
      color = 'primary',
      component = 'a',
      onBlur,
      onFocus,
      TypographyClasses,
      underline = 'always',
      variant = 'inherit',
      sx
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = (0,useIsFocusVisible/* default */.Z)();
  const [focusVisible, setFocusVisible] = react.useState(false);
  const handlerRef = (0,useForkRef/* default */.Z)(ref, focusVisibleRef);
  const handleBlur = event => {
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }
    if (onBlur) {
      onBlur(event);
    }
  };
  const handleFocus = event => {
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);
    }
    if (onFocus) {
      onFocus(event);
    }
  };
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    component,
    focusVisible,
    underline,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRoot, (0,esm_extends/* default */.Z)({
    color: color,
    className: (0,clsx/* default */.Z)(classes.root, className),
    classes: TypographyClasses,
    component: component,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: handlerRef,
    ownerState: ownerState,
    variant: variant,
    sx: [...(!Object.keys(colorTransformations).includes(color) ? [{
      color
    }] : []), ...(Array.isArray(sx) ? sx : [sx])]
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Link_Link = (Link);

/***/ }),

/***/ 72883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ audience; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx
var Footer = __webpack_require__(91001);
// EXTERNAL MODULE: ./src/contexts/CustomThemeProvider.tsx + 2 modules
var CustomThemeProvider = __webpack_require__(75044);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/StyledEngineProvider/StyledEngineProvider.js
var StyledEngineProvider = __webpack_require__(94810);
// EXTERNAL MODULE: ./src/components/index.ts + 109 modules
var components = __webpack_require__(1356);
// EXTERNAL MODULE: ./src/pages/Audience/BookingManager/Steps/Session/SessionStep.styles.ts
var SessionStep_styles = __webpack_require__(94826);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
;// CONCATENATED MODULE: ./src/pages/Audience/AudienceShows.styles.ts


var TitleContainer = (0,styled/* default */.ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    maxWidth: "620px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    alignSelf: "stretch",
    gap: theme.space._500
  };
});
var TitleTypography = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    fontFamily: theme.fonts["default"],
    fontSize: theme.fontSizes["8xl"],
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim,
    color: theme.colors.white,
    "@media (max-width: 600px)": {
      minHeight: 0,
      fontSize: theme.fontSizes["6xl"]
    }
  };
});
var SubtitleTypography = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    fontFamily: theme.fonts["default"],
    fontSize: theme.fontSizes.lg,
    fontWeight: theme.fontWeights.regular,
    lineHeight: theme.lineHeights.tall,
    whiteSpace: "pre-wrap",
    color: theme.colors["neutral.500"]
  };
});
var PageContainer = (0,styled/* default */.ZP)("div")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "8rem",
    gap: theme.space._700,
    padding: "0 ".concat(theme.space._900, " ").concat(theme.space._900, " ").concat(theme.space._900),
    "@media (max-width: 600px)": {
      padding: "0 ".concat(theme.space._400, " ").concat(theme.space._400, " ").concat(theme.space._400)
    }
  };
});
// EXTERNAL MODULE: ./src/services/ShowV2Service.tsx
var ShowV2Service = __webpack_require__(48084);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/pages/Audience/AudienceShows.tsx










var AudienceShows = function AudienceShows(_ref) {
  var router = _ref.router;

  var _useState = (0,react.useState)(null),
      shows = _useState[0],
      setShows = _useState[1];

  var onShowCardClickHandler = function onShowCardClickHandler(show) {
    router.push("/audience/".concat(show.publicRouteUrl));
  };

  (0,react.useEffect)(function () {
    readShows();
  }, []);

  var readShows = function readShows() {
    (0,ShowV2Service/* readShowsAudience */.jt)().then(function (showResponse) {
      if (showResponse.data) {
        var availableShows = showResponse.data;
        setShows(availableShows);
      }
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledEngineProvider/* default */.Z, {
    injectFirst: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components/* NavigationBar */.vx, {
      showHomeIconOnMobile: false,
      showMenu: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SessionStep_styles/* GlobalContainer */.iI, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PageContainer, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SessionStep_styles/* MaxWidthContainer */.ah, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TitleContainer, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TitleTypography, {
              children: "Upcoming Shows"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubtitleTypography, {
              children: "You're in the right place! That's The Ticket is Australia's #1 Destination for tickets to be a part of the studio audience for Australia's biggest television shows! What's more, TICKETS ARE ALWAYS FREE!!"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ShowSelection */.L6, {
            onShowCardClickHandler: onShowCardClickHandler,
            shows: shows
          })]
        })
      })
    })]
  });
};

/* harmony default export */ var Audience_AudienceShows = ((0,next_router.withRouter)(AudienceShows));
;// CONCATENATED MODULE: ./pages/audience/index.tsx










var ShowDetailsPage = function ShowDetailsPage() {
  var router = (0,next_router.useRouter)();
  var promoCode = router.query.promoCode;

  var _useColorModeContext = (0,CustomThemeProvider/* useColorModeContext */.XE)(),
      setColorMode = _useColorModeContext.setColorMode;

  setColorMode("dark");
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Shows | That's The Ticket"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Shows"
      }, "ogTitle"), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:title",
        content: "Shows"
      }, "twitterTitle")]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Audience_AudienceShows, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

var __N_SSP = true;
/* harmony default export */ var audience = ((0,next_router.withRouter)(ShowDetailsPage));

/***/ }),

/***/ 91001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23795);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





function Footer() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    sx: {
      color: "#ffffff",
      margin: "5rem 0 2rem"
    },
    variant: "body2",
    color: "text.secondary",
    align: "center",
    children: ['Copyright © ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      color: "inherit",
      href: "#",
      children: "That's The Ticket"
    }), ' ', new Date().getFullYear(), "."]
  });
}

/***/ }),

/***/ 94826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vm": function() { return /* binding */ ListContainer; },
/* harmony export */   "_z": function() { return /* binding */ PageContainer; },
/* harmony export */   "ah": function() { return /* binding */ MaxWidthContainer; },
/* harmony export */   "iI": function() { return /* binding */ GlobalContainer; }
/* harmony export */ });
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90948);

var GlobalContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return {
    position: "relative",
    width: "100%",
    maxWidth: "1440px",
    marginLeft: "auto",
    marginRight: "auto"
  };
});
var MaxWidthContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    maxWidth: "875px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.space._700
  };
});
var ListContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "3rem",
    alignSelf: "stretch"
  };
});
var PageContainer = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("div")(function (_ref4) {
  var theme = _ref4.theme;
  return {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "-".concat(theme.space._1000),
    gap: theme.space._700,
    padding: "0 ".concat(theme.space._900, " ").concat(theme.space._900, " ").concat(theme.space._900),
    "@media (max-width: 992px)": {
      marginTop: "-".concat(theme.space._800),
      gap: theme.space._600,
      padding: "0 ".concat(theme.space._400, " ").concat(theme.space._400, " ").concat(theme.space._400)
    }
  };
});

/***/ }),

/***/ 48084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jp": function() { return /* binding */ readShowByAllocationId; },
/* harmony export */   "jt": function() { return /* binding */ readShowsAudience; },
/* harmony export */   "tj": function() { return /* binding */ readShow; }
/* harmony export */ });
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50029);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_models_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53901);
/* harmony import */ var src_utils_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89092);




var readShow = /*#__PURE__*/function () {
  var _ref = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(publicUrl) {
    var response, problemDetails, showDetails;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof publicUrl === "undefined" || publicUrl === null)) {
              _context.next = 2;
              break;
            }

            throw new Error("Invalid show URL.");

          case 2:
            _context.next = 4;
            return (0,src_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v2/shows/".concat(publicUrl));

          case 4:
            response = _context.sent;

            if (!(response.status === 403)) {
              _context.next = 10;
              break;
            }

            _context.next = 8;
            return response.json();

          case 8:
            problemDetails = _context.sent;
            throw new Error(problemDetails.title, {
              cause: 403
            });

          case 10:
            if (!(response.status >= 400 && response.status < 600)) {
              _context.next = 12;
              break;
            }

            throw new Error("Oops! It looks like there's a hiccup. Please try again or contact support if the issue persists.");

          case 12:
            _context.next = 14;
            return response.json();

          case 14:
            showDetails = _context.sent;
            return _context.abrupt("return", new src_models_types__WEBPACK_IMPORTED_MODULE_1__/* .ShowV2Response */ .Su({
              data: showDetails
            }));

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function readShow(_x) {
    return _ref.apply(this, arguments);
  };
}();
var readShowByAllocationId = /*#__PURE__*/function () {
  var _ref2 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(allocationId) {
    var response, problemDetails, showDetails;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(typeof allocationId === "undefined" || allocationId === null)) {
              _context2.next = 2;
              break;
            }

            throw new Error("Invalid show URL.");

          case 2:
            _context2.next = 4;
            return (0,src_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .fetchWithAuth */ .ri)("/api/backend/v2/shows/allocations/".concat(allocationId));

          case 4:
            response = _context2.sent;

            if (!(response.status === 403)) {
              _context2.next = 10;
              break;
            }

            _context2.next = 8;
            return response.json();

          case 8:
            problemDetails = _context2.sent;
            throw new Error(problemDetails.title, {
              cause: 403
            });

          case 10:
            if (!(response.status >= 400 && response.status < 600)) {
              _context2.next = 12;
              break;
            }

            throw new Error("Oops! It looks like there's a hiccup. Please try again or contact support if the issue persists.");

          case 12:
            _context2.next = 14;
            return response.json();

          case 14:
            showDetails = _context2.sent;
            return _context2.abrupt("return", new src_models_types__WEBPACK_IMPORTED_MODULE_1__/* .ShowV2Response */ .Su({
              data: showDetails
            }));

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function readShowByAllocationId(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var readShowsAudience = /*#__PURE__*/function () {
  var _ref3 = (0,_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)( /*#__PURE__*/_home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3() {
    var res, resJson, message;
    return _home_vsts_work_1_s_ThatIsTheTicket_FE_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return (0,src_utils_auth__WEBPACK_IMPORTED_MODULE_2__/* .defaultFetch */ .zo)("/api/backend/v2/shows/audience");

          case 3:
            res = _context3.sent;

            if (!(res.status >= 400 && res.status < 600)) {
              _context3.next = 7;
              break;
            }

            console.error("Server not returned a valid response");
            return _context3.abrupt("return", new src_models_types__WEBPACK_IMPORTED_MODULE_1__/* .AudiencePageResponse */ .NA({
              error: 'Unable to load shows'
            }));

          case 7:
            _context3.next = 9;
            return res.json();

          case 9:
            resJson = _context3.sent;
            return _context3.abrupt("return", new src_models_types__WEBPACK_IMPORTED_MODULE_1__/* .AudiencePageResponse */ .NA({
              data: resJson === null || resJson === void 0 ? void 0 : resJson.shows
            }));

          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](0);

            if (_context3.t0 instanceof Error) {
              message = _context3.t0.message;
            } else {
              message = 'Unable to load shows';
            }

            return _context3.abrupt("return", new src_models_types__WEBPACK_IMPORTED_MODULE_1__/* .AudiencePageResponse */ .NA({
              error: message
            }));

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 13]]);
  }));

  return function readShowsAudience() {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ 91867:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/audience",
      function () {
        return __webpack_require__(72883);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(16505)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(91867); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);